<script>
    
    import { onMount } from 'svelte';

    import { db } from './firebase.config.js';
    import OneHBCU from './OneHBCU.svelte';
    import OneHBCU2 from './OneHBCU2.svelte';

    // Form Text
    let text = 'some task';
    let hbcus=[]

	onMount(async () => {
        const url = "./schools.json"
		const res = await fetch(url, {headers: { 'Content-Type': 'application/json'}});
		hbcus = await res.json();
        
	});

</script>


    <!--{JSON.stringify( hbcus)}-->
	{#each hbcus as hbcu}

        <OneHBCU2 id={hbcu.id} hbcu={hbcu}/>
        
	{/each}

